import { render, staticRenderFns } from "./add-mssp-modal.vue?vue&type=template&id=b2e7f9b8&"
import script from "./add-mssp-modal.vue?vue&type=script&lang=tsx&"
export * from "./add-mssp-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./add-mssp-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports